import { RouteType } from "routes/types";
import { lazy } from "react";

const Element = lazy(() => import("./index"));

const route: RouteType = {
  id: 300005,
  parentId: 300000,
  name: "MarkdownGuide",
  label: "Markdown Guide",
  path: "markdown-guide",
  icon: "document",
  element: Element,
  admin: false,
  hidden: false,
};

export default route;
